<template>
  <div class="b-frame-card__wrapper">
    <div class="b-frame-card b-frame-card--midnight-green">
      <div class="b-frame-card__img">
        <a v-if="href" :href="href" :aria-label="ariaLabel">
          <img :src="image" :alt="alt" />
        </a>
        <img v-else :src="image" :alt="alt" />

        <div v-if="instagram" class="card-badge">
          <div class="e-label e-label--bg e-label--instagram">
            {{ badgeContent }}
          </div>
        </div>
        <div v-if="facebook" class="card-badge">
          <div class="e-label e-label--bg e-label--facebook">
            {{ badgeContent }}
          </div>
        </div>
      </div>
      <div class="b-frame-card__content">
        <h3 v-if="date" class="b-frame-card__pre-title">{{ date }}</h3>
        <h3 class="b-frame-card__title">{{ title }}</h3>
        <div v-if="href" class="b-frame-card__btn-area">
          <a :href="href" :aria-label="ariaLabel" class="b-frame-card__cta"></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    badgeContent: { default: '', type: String },
    image: { default: '', type: String },
    instagram: { default: false, type: Boolean },
    facebook: { default: false, type: Boolean },
    date: { default: '', type: String },
    title: { default: '', type: String },
    href: { default: '', type: String },
    ariaLabel: { default: '', type: String },
    alt: { default: '', type: String },
  },
}
</script>
